import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class CodePromoBlocPartenaireComponent extends React.Component {
    renderPluralConditionnal(partner) {
        return partner.couponCount > 1 ? 's' : '';
    }

    render() {
        const { i18n, cssClassContainer } = this.props;
        return (
            <div className={`${cssClassContainer ? cssClassContainer : ''} flex-container-v`}>
                <div className="valeur code-promo">
                    {this.props.partner.couponCount} {i18n.code}
                    {this.renderPluralConditionnal(this.props.partner)}
                    <br />
                    {i18n.dereduction}
                </div>
            </div>
        );
    }
}

CodePromoBlocPartenaireComponent.propTypes = {
    partner: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    cssClassContainer: PropTypes.string
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        i18n: state.i18n.feature.partenaire
    };
};

export default connect(mapStateToProps)(CodePromoBlocPartenaireComponent);



// WEBPACK FOOTER //
// ./src/components/partner/CodePromoBlocPartenaireComponent.js